import React, {useEffect, useState, useRef} from 'react'
import InputMask from 'react-input-mask'
import { Link, NavLink } from 'react-router-dom'

import CUSTOMER_OPT_IN_ACTIONS from './state/customerTextOptInActions'

import './customerTextOptInPage.scss'

export default function CustomerTextOptInPage(props){
  const { dealerName } = props
  const [mobileNumberField, setMobileNumberField] = useState('')
  const [acceptGeneralTexts, setAcceptGeneralTexts] = useState(false)
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false)

  const mobileNumberInputRef = useRef(null)
  // useEffect(()=>{
  //   mobileNumberInputRef.current.focus()
  // },[])
  const handleUpdateMobileNumberField = (e)=>{
    if(e.target.value){
      let rawMobileNumber = e.target.value.replace('+1', '');
      rawMobileNumber =  rawMobileNumber.replace(/\D/g, '');
      setMobileNumberField(rawMobileNumber)
    }
  }
  const allowSubmit = mobileNumberField.length>=10 && acceptGeneralTexts
  console.log(mobileNumberField, mobileNumberField.length>=10)
  const handleSubmit = (e) =>{
    e.preventDefault()
    if(allowSubmit){
      CUSTOMER_OPT_IN_ACTIONS.submitOptIn(dealerName, mobileNumberField).then(response=>{
        setSubmissionSuccessful(true)
      })
    }
  }
  return(
    <div className="customer-text-opt-in-page-container">
      <div className="customer-text-opt-in-page">
      <div className="customer-text-opt-in-form-container">
        {
          submissionSuccessful?
            <div className="customer-text-opt-in-success-container">
              <div className="customer-text-opt-in-success">
                <span>{`${dealerName} can now send you text messages`}</span>
                <br/>
                <div className="customer-text-opt-in-success-button" onClick={()=>{window.location.href='/'}}>Return to Home</div>
              </div>
            </div>
          :
          null

        }
        <div className={`customer-text-opt-in-form-header${submissionSuccessful?' hidden':''}`}>
          {`SIGN UP FOR YOUR PERSONALIZED VEHICLE PRESENTATION FROM` } <br/><span>{`${dealerName}`}</span>
        </div>
        <form className={`customer-text-opt-in-form${submissionSuccessful?' hidden':''}`} onSubmit={handleSubmit}>
          <div className="customer-text-opt-in-form-input-container">
            <InputMask autoFocus inputRef={mobileNumberInputRef} className=""  value={mobileNumberField} mask="+1-999-999-9999" onChange={(e)=>{handleUpdateMobileNumberField(e)}}  />
          </div>
          <div className="customer-text-opt-in-form-disclaimer">
            <div className="customer-text-opt-in-form-disclaimer-checkbox">
              <input type="checkbox" value={acceptGeneralTexts} onChange={(e)=>{setAcceptGeneralTexts(e.target.checked)}}/>
            </div>
            <div className="customer-text-opt-in-form-disclaimer-info">
              {`I consent to receive informational text messages from ${dealerName} at the number I provided related to my inquiries, transactions, and interactions with the dealership. Consent is not a condition of purchase. Msg & data rates may apply.`}
            </div>
          </div>
          <a href="https://www.ipacket.us/sms-terms-of-use/" rel="noopener noreferrer" target="_blank">Click here to review our Privacy Policy or SMS Terms of Service</a>
          <br/>
          <input className="customer-text-opt-in-form-submit" type="submit"  value={`Confirm`} disabled={!allowSubmit} />
        </form>
      </div>

      </div>
    </div>
  )
}
